import {
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    styled,
    Typography,
} from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

import {Colors} from 'appearance'
import {useI18n} from 'store/Store'
import {components, icons, settings} from 'constants/settings'
import {useState} from 'react'
import Accordion from 'components/Display/Accordion'
import {useLocation} from 'react-router-dom'
import analyticsService from 'services/analytic'

const SimpleSettingsItem = ({
    itemName,
    item,
    useSaveItemMutation,
    activities,
    onSelectPeriod,
    Icon,
    isMobile,
}) => {
    const {state} = useLocation()
    const {paymentMethods} = state || {}

    const {i18n} = useI18n()
    const titles = settings[itemName]
    const [selected, setSelected] = useState(
        paymentMethods ? 'paymentTypes' : null
    )

    const {payments} = activities || {}

    const onSelect = (key) => {
        setSelected(key)
        analyticsService.paymentSettingsPressed(
            key === 'paymentTypes' ? 'payment_methods' : 'subscription'
        )
    }

    const LeftSideComponent = selected
        ? components[itemName][selected]
        : () => <></>

    return (
        <StyledAccordion
            title={i18n.t(`settings.${itemName}`)}
            Icon={Icon}
            defaultExpanded={paymentMethods}>
            <Content isMobile={isMobile}>
                <Details>
                    <List dense style={{direction: 'rtl'}}>
                        {titles.map((title) => {
                            if (title === 'paymentsList' && !payments?.length) {
                                return null
                            }
                            const Icon = icons[title]
                            return (
                                <>
                                    <ListButton
                                        key={title}
                                        onClick={() => onSelect(title)}
                                        selected={title === selected}>
                                        <ListItem key={title}>
                                            <ListItemContent>
                                                <ListText>
                                                    <ListItemIcon>
                                                        <Icon />
                                                    </ListItemIcon>
                                                    {i18n.t(
                                                        `settings.${title}`
                                                    )}
                                                </ListText>
                                                <IconButton size="small">
                                                    <ArrowBackIosNewIcon />
                                                </IconButton>
                                            </ListItemContent>
                                        </ListItem>
                                    </ListButton>
                                    {isMobile && title === selected && (
                                        <LeftSideComponent
                                            onSelectPeriod={onSelectPeriod}
                                            item={item}
                                            isMobile={true}
                                        />
                                    )}
                                </>
                            )
                        })}
                    </List>
                </Details>
                {!isMobile && (
                    <>
                        <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                        />
                        <LeftSide>
                            <LeftSideComponent
                                onSelectPeriod={onSelectPeriod}
                                item={item}
                            />
                        </LeftSide>
                    </>
                )}
            </Content>
        </StyledAccordion>
    )
}

export default SimpleSettingsItem

const StyledAccordion = styled(Accordion)`
    /* margin-bottom: 24px; */
`

const Content = styled('div')`
    display: flex;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
    width: 100%;
`

const Details = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 2;
    padding: 24px;
`

const ListText = styled(Typography)`
    display: flex;
    align-items: center;
`

const ListButton = styled(ListItemButton)`
    border-radius: 6px;
    &.Mui-selected {
        background: ${Colors.LIGHT_BLUE};
    }
`

const ListItemContent = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

const LeftSide = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 2;
    gap: 12px;
    padding: 24px;
`
